import React from 'react';
import T from './T';

export default class ValidationMessage extends React.Component {
  render() {
    const { msg } = this.props;

    if (!msg) return null;

    const msgs = Array.isArray(msg) ? msg : [msg];

    return msgs.map((msg, i) =>
      <div key={i} className="c-input__validation-msg"><T msg={msg} /></div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/Assets/js/features/components/ValidationMessage.js